<template>
  <div class="pop">
    <el-dialog @close="closeCpToast" @open="openToast" :width="slot == 'statisticsDialog2' || slot == 'statisticsDialog7' ? '1140px' : slot == 'statisticsDialog4' ? '1360px' : '775px'" title="" :visible.sync="$parent.dialogTableVisible">
      <!-- 版权图片用量明细 -->
      <div v-if="slot == 'statisticsDialog1'" style="padding-bottom: 20px">
        <DialogHeader @exportList="exportList(1)" @refresh="refresh(1)" title="版权图片用量-明细"></DialogHeader>
        <div style="min-height: 400px">
          <el-table v-loading="$parent.loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loadmore="$parent.loadMore" :data="list" v-if="list.length" height="400" :header-cell-style="{ background: '#F7F6F9' }">
            <el-table-column prop="statistics_date" label="日期"></el-table-column>
            <el-table-column prop="used_copyright_image_today" label="用量"></el-table-column>
            <el-table-column prop="use_times_day" label="用次"></el-table-column>
          </el-table>
          <no-content v-if="!list.length && $parent.loadShow" :text="'暂无数据'" :url="url" :bgUrlShow="bgUrlShow" />
        </div>
      </div>
      <!-- 版权图片使用数据明细 -->
      <div v-if="slot == 'statisticsDialog2'" style="padding-bottom: 20px">
        <DialogHeader @exportList="exportList(2)" @refresh="refresh(2)" title="版权图片使用数据-明细"></DialogHeader>
        <div style="min-height: 500px">
          <el-table v-loading="$parent.loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loadmore="$parent.loadMore" :data="list" v-if="list.length" height="500" :header-cell-style="{ background: '#F7F6F9' }">
            <el-table-column prop="created_at" label="加入时间"></el-table-column>
            <el-table-column prop="team_style_id" label="图片ID"></el-table-column>
            <el-table-column label="图片">
              <template slot-scope="scope">
                <el-popover placement="right" trigger="hover" popper-class="popover">
                  <div class="popimg">
                    <img :src="scope.row.img" alt="" class="imgcon" />
                  </div>
                  <div slot="reference" style="width: 36px; height: 36px; background: #f7f6f9; border-radius: 4px">
                    <img :src="scope.row.img" alt="" class="imgcon" />
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="used_times" label="使用次数"></el-table-column>
            <el-table-column prop="image_source" label="图片来源"></el-table-column>
            <el-table-column prop="nick_name" label="加入人" :show-overflow-tooltip="true"></el-table-column>
          </el-table>
          <no-content v-if="!list.length && $parent.loadShow" :text="'暂无数据'" :url="url" :bgUrlShow="bgUrlShow" />
        </div>
      </div>
      <!-- 成员情况明细 -->
      <div v-if="slot == 'statisticsDialog3'" style="padding-bottom: 20px">
        <DialogHeader @exportList="exportList(3)" @refresh="refresh(3)" title="成员情况-明细"></DialogHeader>
        <div style="min-height: 400px">
          <el-table v-loading="$parent.loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loadmore="$parent.loadMore" :data="list" v-if="list.length" height="400" :header-cell-style="{ background: '#F7F6F9' }">
            <el-table-column prop="date" label="日期"></el-table-column>
            <el-table-column prop="new_account" label="新增用户"></el-table-column>
            <el-table-column prop="active_account" label="活跃账户数"></el-table-column>
          </el-table>
          <no-content v-if="!list.length && $parent.loadShow" :text="'暂无数据'" :url="url" :bgUrlShow="bgUrlShow" />
        </div>
      </div>
      <!-- 成员作品数据明细 -->
      <div v-if="slot == 'statisticsDialog4'" style="min-height: 656px">
        <DialogHeader @exportList="exportList(4)" @refresh="refresh(4)" title="成员作品数据-明细" :loadingStatus="$parent.loading"></DialogHeader>
        <div style="min-height: 500px">
          <el-table v-loading="$parent.loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loadmore="$parent.loadMore" :data="list" v-if="list.length" height="520" :header-cell-style="{ background: '#F7F6F9' }">
            <el-table-column prop="user.created_at" label="加入时间" width="200"></el-table-column>
            <el-table-column prop="user.login_at" label="最后登录时间" width="200"></el-table-column>

            <el-table-column prop="user_id" label="成员编号"></el-table-column>
            <el-table-column prop="user.nick_name" label="成员名" width="200" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="create_num" label="创建模版" sortable width="120"></el-table-column>
            <el-table-column prop="team_num" label="设为企业模版" sortable width="130"></el-table-column>
            <el-table-column prop="down_num" label="下载模版" sortable width="120"></el-table-column>
            <el-table-column label="下载样式预览" width="250">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center" class="allimg">
                  <el-popover v-for="(img, index) in scope.row.down_design" :key="index" placement="right" trigger="hover" popper-class="popover">
                    <div class="popimg" v-if="index < 3">
                      <img :src="issafariBrowser ? img.img : img.thumbnail_img" alt="" class="imgcon" />
                    </div>
                    <div v-if="index < 3" slot="reference" style="width: 36px; height: 36px; background: #f7f6f9; border-radius: 4px">
                      <img :src="issafariBrowser ? img.img : img.thumbnail_img" alt="" class="imgcon" />
                    </div>
                  </el-popover>
                  <div v-if="scope.row.down_design.length" @click="$parent.gotoTemp(scope.row.user_id, 1)" style="font-size: 14px; color: #5a2df5; cursor: pointer">全部</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <no-content v-if="!list.length && $parent.loadShow" :text="'暂无数据'" :url="url" :bgUrlShow="bgUrlShow" />
        </div>
        <Pagination v-if="$parent.Pagination.total > 10" style="padding-bottom: 30px" @handleCurrentChange="$parent.handleCurrentChange" :Pagination="$parent.Pagination" />
      </div>
      <!-- 企业空间作品 -->
      <div v-if="slot == 'statisticsDialog5'" style="padding-bottom: 20px">
        <DialogHeader @exportList="exportList(5)" @refresh="refresh(5)" title="企业空间作品-明细"></DialogHeader>
        <div style="min-height: 400px">
          <el-table v-loading="$parent.loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loadmore="$parent.loadMore" :data="list" v-if="list.length" height="400" :header-cell-style="{ background: '#F7F6F9' }">
            <el-table-column prop="date" label="日期"></el-table-column>
            <el-table-column prop="team_template_num" label="企业空间模版(总数)"></el-table-column>
            <el-table-column prop="team_template_new_num" label="企业空间模版(新增数)"></el-table-column>
          </el-table>
          <no-content v-if="!list.length && $parent.loadShow" :text="'暂无数据'" :url="url" :bgUrlShow="bgUrlShow" />
        </div>
      </div>
      <!-- 个人空间作品 -->
      <div v-if="slot == 'statisticsDialog6'" style="padding-bottom: 20px">
        <DialogHeader @exportList="exportList(6)" @refresh="refresh(6)" title="个人空间作品-明细"></DialogHeader>
        <div style="min-height: 400px">
          <el-table v-loading="$parent.loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loadmore="$parent.loadMore" :data="list" v-if="list.length" height="400" :header-cell-style="{ background: '#F7F6F9' }">
            <el-table-column prop="date" label="日期"></el-table-column>
            <el-table-column prop="team_user_design_num" label="个人空间模版(总数)"></el-table-column>
            <el-table-column prop="team_user_design_new_num" label="个人空间模版(新增数)"></el-table-column>
          </el-table>
          <no-content v-if="!list.length && $parent.loadShow" :text="'暂无数据'" :url="url" :bgUrlShow="bgUrlShow" />
        </div>
      </div>
      <!-- 作品下载数据 -->
      <div v-if="slot == 'statisticsDialog7'" style="min-height: 656px">
        <DialogHeader @exportList="exportList(7)" @refresh="refresh(7)" title="作品下载数据-明细"></DialogHeader>
        <div style="min-height: 500px">
          <el-table v-loading="$parent.loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loadmore="$parent.loadMore" :data="list" v-if="list.length" height="520" :header-cell-style="{ background: '#F7F6F9' }">
            <!-- <el-table-column label="模版ID">
              <template slot-scope="scope">
                <p v-if="scope.row.template">{{ scope.row.template.id }}</p>
                <p v-else>已删除</p>
              </template>
            </el-table-column> -->
            <el-table-column label="模版预览">
              <template slot-scope="scope" v-if="scope.row.template">
                <el-popover placement="right" trigger="hover" popper-class="popover">
                  <div class="popimg">
                    <img :src="issafariBrowser ? scope.row.template.cover_url : scope.row.template.thumbnail_cover_url" alt="" class="imgcon" />
                  </div>
                  <div slot="reference" style="width: 36px; height: 36px; background: #f7f6f9; border-radius: 4px">
                    <img :src="issafariBrowser ? scope.row.template.cover_url : scope.row.template.thumbnail_cover_url" alt="" class="imgcon" />
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="nick_name" label="创建者" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="down_num" label="下载次数" sortable></el-table-column>
            <el-table-column label="下载列表" width="300">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center" class="allimg">
                  <el-popover v-for="(img, index) in scope.row.download" :key="index" placement="right" trigger="hover" popper-class="popover">
                    <div class="popimg" v-if="index < 3">
                      <img :src="issafariBrowser ? img.img : img.thumbnail_img" alt="" class="imgcon" />
                    </div>
                    <div v-if="index < 3" slot="reference" style="width: 36px; height: 36px; background: #f7f6f9; border-radius: 4px">
                      <img :src="issafariBrowser ? img.img : img.thumbnail_img" alt="" class="imgcon" />
                    </div>
                  </el-popover>
                  <div v-if="scope.row.download && scope.row.download.length" @click="$parent.gotoTemp(scope.row.template.id, 2)" style="font-size: 14px; color: #5a2df5; cursor: pointer">全部</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <no-content v-if="!list.length && $parent.loadShow" :text="'暂无数据'" :url="url" :bgUrlShow="bgUrlShow" />
        </div>
        <Pagination v-if="$parent.Pagination.total > 10" style="padding-bottom: 30px" @handleCurrentChange="$parent.handleCurrentChange" :Pagination="$parent.Pagination" />
      </div>
      <!-- 活跃账号数 -->
      <div v-if="slot == 'statisticsDialog8'" style="padding-bottom: 20px">
        <DialogHeader @exportList="exportList(8)" @refresh="refresh(8)" title="活跃账号数-明细"></DialogHeader>
        <div style="min-height: 400px">
          <el-table v-loading="$parent.loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loadmore="$parent.loadMore" :data="list" v-if="list.length" height="400" :header-cell-style="{ background: '#F7F6F9' }">
            <el-table-column prop="date" label="日期"></el-table-column>
            <el-table-column prop="active_account" label="活跃账号数"></el-table-column>
          </el-table>
          <no-content v-if="!list.length && $parent.loadShow" :text="'暂无数据'" :url="url" :bgUrlShow="bgUrlShow" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DialogHeader from "./dialogHeader.vue";
import Index from "@/config/mixin/index.js";
import noContent from "@/components/common/noContent.vue";
export default {
  mixins: [Index],
  name: "dialog",
  props: ["list", "slot", "url", "bgUrlShow"],
  components: {
    DialogHeader,
    noContent,
  },
  data() {
    return {
      issafariBrowser: "",
    };
  },
  mounted() {
    this.issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
  },
  methods: {
    // 关闭弹窗初始化数据
    closeCpToast() {
      this.$parent.list = []; //要清空的数据
      this.$parent.page = 1;
      this.$parent.aq = true;
      this.$parent.loadShow = true;
    },
    // 刷新按钮
    refresh(num) {
      if (this.$parent.loading) {
        return;
      }
      this.$parent.loading = true;

      // this.$parent.loading = this.$loading({
      //   lock: true,
      //   text: '拼命加载中',
      //   spinner: 'el-icon-loading'
      // });
      this.$parent.loadShow = false;
      this.$parent.list = [];
      if (this.$parent.load) {
        if (num == 4) {
          this.$parent.Pagination.page = 1;
          this.$parent.statistics_design_data_list();
        } else if (num == 7) {
          this.$parent.Pagination.page = 1;
          this.$parent.statistics_enterprise_design_download_data_list();
        } else {
          this.$parent.page = 0;
          this.$parent.aq = true;
          this.$parent.loadMore();
        }
      }
    },
    exportList(num) {
      if (num == 1) {
        this.$parent.statistics_use_num_details_export();
      }
      if (num == 2) {
        this.$parent.statistics_use_list_export();
      }
      if (num == 3) {
        this.$parent.statistics_detail_export();
      }
      if (num == 4) {
        this.$parent.statistics_design_data_export();
      }
      if (num == 5) {
        this.$parent.statistics_enterprise_design_detail_export();
      }
      if (num == 6) {
        this.$parent.statistics_personal_design_download_data_export();
      }
      if (num == 7) {
        this.$parent.statistics_enterprise_design_download_data_export();
      }
      if (num == 8) {
        this.$parent.statistics_active_details_export();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mctitle {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3b3946;
  background: #ffffff;
  border-radius: 4px;
}

.allimg {
  ::v-deep( .el-popover__reference) {
    margin-right: 6px;
  }
}

.mc_top {
  margin: 0 24px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  height: 54px;
  border-bottom: 1px solid #f0eef3;

  .left {
    display: flex;
    align-items: center;
  }

  .p1 {
    width: 4px;
    height: 16px;
    background: #5a2df5;
    border-radius: 1px;
    margin-right: 8px;
  }

  .p2 {
    color: #3b3946;
  }

  .rightbtn {
    display: flex;
    margin-left: auto;

    ul {
      cursor: pointer;
      width: 68px;
      height: 28px;
      background: rgba(255, 255, 255, 0);
      border-radius: 4px;
      border: 1px solid #5a2df5;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5a2df5;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 14px;

      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.popimg {
  width: 500px;
  height: 500px;
  background: #f7f6f9;
  box-shadow: 0px 10px 30px 6px rgba(0, 0, 0, 0.1);
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep( .el-table thead) {
  color: #3b3946;
  font-weight: 500;
}

.imgcon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

::v-deep( .el-table::before) {
  height: 0;
}
</style>
